import { useEffect, useState } from "react"
import { getAllTopics } from "../services/topicService"


const useTopic = ({search_text = null, course_id= null}={}) => {
    let [topics, setTopic] = useState([])
    let [loading, setLoading] = useState(false)
    let [error, setError] = useState(null)

    useEffect(() => {
        fetchTopics({course_id, search_text});
    }, [])

    const fetchTopics = async ({search_text=null, course_id=null, department_id=null, faculty_id=null, level=null, with_quiz=null}={}) => {
        setLoading(true)
        try {
            const data = await getAllTopics({
                search_text, 
                course_id,
                department_id,
                faculty_id,
                level,
                with_quiz,
            })
            setTopic(data)
        } catch (error) {
            setError(error)
        } finally {
            setLoading(false)
        }
    }


    return {
        topics,
        loading,
        error,
        fetchTopics,
    };
};

export default useTopic;